module.exports = __webpack_public_path__ + "img/assurance.7eb2b7d9.jpg";